import { ColTypeDef, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { ISalesCounterpart } from 'models/ISalesCounterpart';
import { useMemo } from 'react';
import { CellRendererAsEditorWrapper } from 'routes/secondary-market-batch/grid/components/cell-render-as-editor-wrapper';
import { ClientCellEditor } from 'routes/secondary-market-batch/grid/components/client-cell-editor';
import { SecondaryCellEditorProps, SecondaryCellRendererProps } from 'routes/secondary-market-batch/grid/types';
import { equalsById } from 'routes/secondary-market-batch/grid/utils/equals-by-id';
import { RowData } from 'state/workspaces/secondary-market/batch/model';

export function useSalesCounterpartColumnType(): ColTypeDef<RowData, RowData[keyof RowData]> {
  return useMemo(
    () => ({
      filter: 'agTextColumnFilter',
      filterParams: {
        filterOptions: ['contains', 'notContains'],
      },
      valueFormatter: ({ value }: ValueFormatterParams<RowData>) => {
        const custodian = value as ISalesCounterpart | undefined;
        return custodian?.eliotCode!;
      },
      useValueFormatterForExport: true,
      filterValueGetter: ({ getValue, colDef }: ValueGetterParams<RowData>) => {
        const client = colDef.field ? getValue(colDef.field) : (undefined as ISalesCounterpart | undefined);
        return `${client?.label} (${client?.id} - ${client?.eliotCode})`;
      },
      equals: equalsById,
      cellEditor: (p: SecondaryCellEditorProps<ISalesCounterpart>) => <ClientCellEditor {...p} type="editor" />,
      cellRenderer: (p: SecondaryCellRendererProps<ISalesCounterpart>) => (
        <CellRendererAsEditorWrapper {...p} render={ClientCellEditor} />
      ),
    }),
    [],
  );
}
